import { useState } from "react";
import "./scorecardParticipation.css";
import "../../index.css";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import PopUpScorecardFormCollaborate from "../../popUpForms/popUpScorecardFormCollaborate";
import PopUpScorecardFormFeedback from "../../popUpForms/popUpScorecardFormFeedback";
import PopUpScorecardFormContribute from "../../popUpForms/popUpScorecardFormContribute";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";

const ScorecardParticipation = () => {
  const [activeForm, setActiveForm] = useState("");
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [popUpComponent, setPopUpComponent] = useState();

  const handleShowPopUp = (popUpForm) => {
    if (
      popUpForm === "collab" ||
      popUpForm === "feedback" ||
      popUpForm === "contribute"
    ) {
      setActiveForm(popUpForm);
      setPopUpFormVisible(true);
      if (popUpForm === "collab") {
        setPopUpComponent(<PopUpScorecardFormCollaborate />);
      } else if (popUpForm === "feedback") {
        setPopUpComponent(<PopUpScorecardFormFeedback />);
      } else if (popUpForm === "contribute") {
        setPopUpComponent(<PopUpScorecardFormContribute />);
      }
    }
  };

  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-participation">
        <h2>Scorecard Participation and Pilot Feedback</h2>
        <h4 className="para-header">Stakeholders</h4>
        <p className="para-subheader">
          In addition to local community members, example stakeholders include:
        </p>
        <p>
          <ul>
            <li>Local, regional, and national governments</li>
            <li>Fire, water, vegetation, early detection, and other experts</li>
            <li>Insurance companies</li>
            <li>Reinsurance companies/ Insurance linked security companies</li>
            <li>Utility companies</li>
            <li>Social enterprises</li>
            <li>Neighborhood and home-owner associations</li>
            <li>Developers/real estate/ landowners</li>
            <li>Community wildfire organizations</li>
            <li>Local community emergency preparedness associations etc.</li>
          </ul>
        </p>
        <p>
          All communities are expected to have gaps in catastrophic wildfire
          community risk reduction. The objective is to anticipate how
          vulnerabilities to wildfire generate opportunities for catastrophe
          community risk reduction and a chance to learn from others who have
          already embraced some of these strategies. We can amplify network
          effects with accelerated learning from many regions creatively
          reducing their risks and sharing their results in a community of
          practice. <br />
          The ARISE-US/CrowdDoing CWPC Community Wildfire Resilience Scorecard
          has been released as an open source tool.
        </p>

        <h4 className="para-header">Pilot with Us!</h4>
        <p className="para-subheader">
          Communities wishing to pilot our scorecard are invited to do so in
          multiple ways:
        </p>
        <p>
          <ol>
            <li>Self-pilot</li>
            <li>Collaborate with other networks</li>
            <li>Expert review with support for your collaboration</li>
            <li>
              Full collaboration with our consortium of social innovators and
              experts:{" "}
              <span
                className="text-orange custom-modal-btn"
                onClick={() => handleShowPopUp("collab")}
              >
                Collaborate with Us{" "}
                <img
                  src="https://img.icons8.com/material-rounded/ff6701/96/external-link.png"
                  alt=""
                />
              </span>
            </li>
          </ol>
        </p>

        <h4 className="para-header">
          Support our Pilot Initiatives and Wildfire Mitigation
        </h4>
        <p className="para-subheader">
          ARISE-US/CrowdDoing CWPC Community Wildfire Resilience Scorecard is a
          gift to the world to reduce disaster risk. We invite reciprocity to
          help future beneficiaries using this toolset by collaborating to
          improve it. To improve communities’ wildfire resilience through
          scorecard enhancements and adoption, ARISE-US/CrowdDoing CWPC invite
          corporations, institutions, and individuals to support this effort
          with:
        </p>
        <p>
          <ol>
            <li>
              Learnings and data from scorecard testing that can be shared to
              improve the scorecard:{" "}
              <span
                className="text-green custom-modal-btn"
                onClick={() => handleShowPopUp("feedback")}
              >
                Feedback{" "}
                <img
                  src="https://img.icons8.com/material-rounded/65a637/96/external-link.png"
                  alt=""
                />
              </span>
            </li>
            <li>
              Volunteer time, individually or as a team deployment from an
              institution
            </li>
            <li>Subject matter experts</li>
            <li>Datasets, technologies, and / or computer systems capacity</li>
            <li>Sponsorships and other in-kind support</li>
            <li>
              Funding:{" "}
              <span
                className="text-cornflower-blue custom-modal-btn"
                onClick={() => handleShowPopUp("contribute")}
              >
                Support Wildfire Prevention{" "}
                <img
                  src="https://img.icons8.com/material-rounded/0d72ff/96/external-link.png"
                  alt=""
                />
              </span>
            </li>
          </ol>
        </p>
        <p>
          Reach out to us at{" "}
          <a href="mailto:contact@preventwildfire.world">
            contact@preventwildfire.world
          </a>
        </p>
      </div>

      <PopUpModal
        activeForm={activeForm}
        formActiveState={popUpFormVisible}
        setFormActiveState={setPopUpFormVisible}
      >
        {popUpComponent}
      </PopUpModal>
    </>
  );
};

export default ScorecardParticipation;
